import React from "react";
import propTypes from "prop-types";
import classNames from "classnames";
import { DefaultPageContainer as PageContainer } from "@layout";
import { Hero, ContentBuilder } from "@organisms";
import {FooterContact, CbColoredCopy } from "@molecules";
import { CopyBox, Container } from "@atoms";

const HrResourcesPage = ({ data }) => {
  const { hero, subheading, resources, meta } = data;

  return (
    <PageContainer meta={meta}>
      <Hero {...hero} />
      <CbColoredCopy {...subheading} minimalPadding />
      <Container variant="lg">
        <ul className="mt-10 flex flex-wrap justify-center">
          {resources?.map((resource, i) => {
            return (
              <CopyBox {...resource} color="yellow" outline key={i}/>
            );
          })}
        </ul>
      </Container>
      <FooterContact />
    </PageContainer>
  );
};

HrResourcesPage.defaultProps = {};

HrResourcesPage.propTypes = {};

export default HrResourcesPage;
